import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { BedomareClient } from '../clients/etjanster-common-api/bedomare.client';
import { BedomareViewModel } from '../models/bedomare-view-model.model';
import { Bedomare } from '../models/bedomare.model';
import { BedomareRepository } from '../repositories/bedomare.repository';

@Injectable({ providedIn: 'root' })
export class BedomareQuery {
  constructor(
    private bedomareRepository: BedomareRepository,
    private bedomareClient: BedomareClient,
  ) {}

  public fetchCurrentBedomare(): Observable<Bedomare> {
    return this.bedomareClient.fetchCurrentBedomare().pipe(
      map((data) => {
        if (data) {
          if (!data.program) {
            data.program = [];
          }
          if (!data.bedomareNyckelord) {
            data.bedomareNyckelord = [];
          }

          return this.bedomareRepository.setBedomare(data);
        }
      }),
    );
  }

  public fetchBedomareData(): Observable<BedomareViewModel> {
    return this.bedomareClient.fetchBedomareData().pipe(
      map((data) => {
        if (data) {
          this.bedomareRepository.setBedomareData(data);
          return data;
        }
      }),
    );
  }
}
